import { render, staticRenderFns } from "./-hotel-details.vue?vue&type=template&id=85e0758e&scoped=true"
import script from "./-hotel-details.vue?vue&type=script&lang=js"
export * from "./-hotel-details.vue?vue&type=script&lang=js"
import style0 from "./-hotel-details.vue?vue&type=style&index=0&id=85e0758e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e0758e",
  null
  
)

export default component.exports